import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { Button, Icon, Input } from '../../../UI'
import ErrorMessageWithExclamation from '../../../UI/ErrorMessageWithExclamation'

import { CreditCardPaymentScheme } from '../../../../routing/utils/validators'

const TopUpPaymentModalCreditCard = ({ onPayment, error, isLoading, resetError }) => {
  const {
    formState: { errors },
    control,
    handleSubmit,
  } = useForm({
    defaultValues: {
      card_number: '',
      expires_month: '',
      expires_year: '',
      security_code: '',
    },
    resolver: yupResolver(CreditCardPaymentScheme),
  })

  const handleFormSubmit = (data) => {
    console.log(data)

    if (onPayment) {
      onPayment(data)
    }
  }

  const handleCardNumberChange = (e, onChange) => {
    let value = e.target.value

    if (value.length > 19) {
      return
    }

    if (value.length === 4 || value.length === 9 || value.length === 14) {
      value += ' '
    }

    if (value.length === 19) {
      document.querySelector('#expires_month')?.focus?.()
    }

    onChange(value)
  }

  const handleCardExpiresChange = (e, onChange, type) => {
    let value = e.target.value

    if (value.length > 2) {
      return
    }

    if (isNaN(+value)) {
      return
    }

    if (value.length === 2) {
      if (type === 'month') {
        document.querySelector('#expires_year')?.focus?.()
      } else if (type === 'year') {
        document.querySelector('#security_code')?.focus?.()
      }
    }

    onChange(value)
  }

  const handleCardSecurityCodeChange = (e, onChange) => {
    let value = e.target.value

    if (value.length > 3) {
      return
    }

    if (isNaN(+value)) {
      return
    }

    onChange(value)
  }

  useEffect(() => {
    return () => {
      if (resetError) {
        resetError()
      }
    }
  }, [])

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="w-full flex flex-col items-start">
      {!!error && <ErrorMessageWithExclamation text={error} className="mb-[16px]" />}

      <div className="w-full">
        <label htmlFor="card_number" className="mb-[4px] text-sm font-semibold text-primary-100">
          Card Number
        </label>

        <div className="relative w-full flex items-center">
          <Icon
            name="bank-card-fill"
            color="#F79009"
            className="absolute left-[14px] w-[24px] h-[24px] opacity-50"
          />

          <Controller
            control={control}
            name="card_number"
            render={({ field: { onChange, ...field } }) => {
              return (
                <input
                  type="text"
                  inputMode="numeric"
                  id="card_number"
                  className="w-full h-[44px] py-[10px] pl-[44px] pr-[14px] border-[#FFCA84] border-[1px] rounded-[8px] bg-white outline-none text-base text-primary-100"
                  onChange={(e) => handleCardNumberChange(e, onChange)}
                  {...field}
                />
              )
            }}
          />
        </div>

        {errors.card_number && <ErrorMessageWithExclamation text={errors.card_number.message} />}
      </div>

      <div className="w-full flex items-start gap-x-[20px] mt-[24px]">
        <div className="flex-1">
          <span className="inline-block mb-[4px] text-sm font-semibold text-primary-100">
            Expires on
          </span>

          <div className="w-full flex gap-x-[4px]">
            <div className="flex-1 flex items-start flex-col">
              <Controller
                control={control}
                name="expires_month"
                render={({ field: { onChange, ...field } }) => {
                  return (
                    <Input
                      type="text"
                      id="expires_month"
                      inputMode="numeric"
                      placeholder="MM"
                      className="w-full text-base text-primary-100"
                      onChange={(e) => handleCardExpiresChange(e, onChange, 'month')}
                      {...field}
                    />
                  )
                }}
              />

              {errors.expires_month && (
                <ErrorMessageWithExclamation text={errors.expires_month.message} />
              )}
            </div>

            <div className="flex-1 flex items-start flex-col">
              <Controller
                control={control}
                name="expires_year"
                render={({ field: { onChange, ...field } }) => {
                  return (
                    <Input
                      type="text"
                      id="expires_year"
                      inputMode="numeric"
                      placeholder="YY"
                      className="w-full text-base text-primary-100"
                      onChange={(e) => handleCardExpiresChange(e, onChange, 'year')}
                      {...field}
                    />
                  )
                }}
              />

              {errors.expires_year && (
                <ErrorMessageWithExclamation text={errors.expires_year.message} />
              )}
            </div>
          </div>
        </div>

        <div className="flex-1">
          <label
            htmlFor="security_code"
            className="mb-[4px] text-sm font-semibold text-primary-100"
          >
            Security Code
          </label>

          <Controller
            control={control}
            name="security_code"
            render={({ field: { onChange, ...field } }) => {
              return (
                <Input
                  type="text"
                  inputMode="numeric"
                  id="security_code"
                  className="w-full text-base text-primary-100"
                  onChange={(e) => handleCardSecurityCodeChange(e, onChange)}
                  {...field}
                />
              )
            }}
          />

          {errors.security_code && (
            <ErrorMessageWithExclamation text={errors.security_code.message} />
          )}
        </div>
      </div>

      {/* TODO */}
      <Button type="submit" isLoading={isLoading} className="mt-[24px] w-full text-base font-bold">
        Confirm Payment $18
      </Button>

      <p className="mt-[10px] text-sm text-[#F79009]">
        By clicking on “confirm payment“, you agree to our{' '}
        <a href="/" target="_blank" className="font-bold underline hover:text-[#F79009]">
          payment and refund policy
        </a>
        .
      </p>
    </form>
  )
}

export default TopUpPaymentModalCreditCard
